import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_INDICATOR_PRODUCT_SUBSCRIPTION_PATH,
  GetIndicatorProductSubscriptionErrorDto,
  GetIndicatorProductSubscriptionRequestPathVariables,
  GetIndicatorProductSubscriptionRequestQueryParams,
  GetIndicatorProductSubscriptionSuccessDto,
} from '@/api/rest/resources/types/IndicatorProduct';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';
import { assertIsDefined } from '@/utils/assert';

export const useGetIndicatorProductSubscriptions = (organizationIdArg?: string) => {
  const orgId = useOrganizationId();
  const organizationId = organizationIdArg ?? orgId;

  assertIsDefined(organizationId, 'organizationId');

  const queryParams: GetIndicatorProductSubscriptionRequestQueryParams = {
    organization_id: organizationId,
  };

  const queryFn = async () => {
    return getRequest<
      GetIndicatorProductSubscriptionSuccessDto,
      GetIndicatorProductSubscriptionRequestPathVariables,
      GetIndicatorProductSubscriptionRequestQueryParams
    >(GET_INDICATOR_PRODUCT_SUBSCRIPTION_PATH, undefined, queryParams);
  };

  return useSuspenseQuery<GetIndicatorProductSubscriptionSuccessDto, GetIndicatorProductSubscriptionErrorDto>({
    queryKey: ['organization', organizationId, 'indicator-product-subscription'],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
